import type { ActionTree } from 'vuex'

import type { Oneschema } from './types'
import type { RootState } from '@/store/modules/types'
import { getContext } from '@/utils/general'

export const jwtActions: ActionTree<Oneschema, RootState> = {

  async FETCH_ONESCHEMA_JWT({ rootState, commit }) {
    if (!rootState.authModule.account) { return null }
    const { promoterOid } = rootState.authModule.account
    const { $api } = getContext()
    try {
      commit('SET_IS_FETCHING_JWT', true)

      const jwt = await $api.oneschema.fetchJWT(promoterOid)
      commit('SET_ONESCHEMA_JWT', jwt)

      return true
    }
    catch (error) {
      console.error(error)

      return true
    }
    finally {
      commit('SET_IS_FETCHING_JWT', false)
    }
  },
}
